import { Stack,Title,Text } from "@mantine/core";

const TitleWithDescription = ({title, description,icon, color='#000000', size = 'md'}) => {
  
  let titleSize = 'md';
  let descSize = 'sm';

  if (size === 'lg') {
    titleSize = 'lg';
    descSize = 'md';
  } else if (size === 'sm') {
    titleSize = 'sm';
    descSize = 'xs';
  }

  return(
    <Stack gap={5} mb={'10px'}>
      <Text fw={500} c={color} size={titleSize}>
        {icon && <span style={{ marginRight: 6 }}>{icon}</span>}
        {title}
      </Text>
      <Text size={descSize}>{description}</Text>
    </Stack>
  )
}

export default TitleWithDescription;